import i18n from '@dms/i18n';

import {VEHICLE_FORM_EVENTS} from '../../core/machine/constants/VEHICLE_FORM_EVENTS';
import {useVehicleFormContext} from '../hooks/useVehicleFormContext';
import {Field} from './primitives/Field';

/**
 * Numeric input component for entering the mileage at which a vehicle service inspection was last performed.
 * Used in service interval tracking to record the vehicle's mileage when a service inspection was last done.
 * Automatically calculates the next service inspection mileage when changed.
 */
export function LastServiceInspectionMileageInput() {
  const {sendMachineEvent} = useVehicleFormContext();

  const handleChange = (value: number | null) => {
    sendMachineEvent({
      type: VEHICLE_FORM_EVENTS.SERVICE_INSPECTIONS_MILEAGE_CHANGED,
      value,
    });
  };

  return (
    <Field
      type="number"
      name="serviceIntervals.serviceInspection.lastServiceInspectionMileage"
      label={i18n.t('entity.vehicle.labels.lastServiceInspection')}
      suffix={i18n.t('general.metric.km')}
      onChange={handleChange}
    />
  );
}
